import { Navigate, useParams } from "react-router-dom";

/** Legacy create route — create form now lives on the Tickets landing page. */
export function CreateEditTicketPage() {
  return <Navigate to="/psm/tickets" replace />;
}

/** Legacy edit route — editing happens on the Ticket Detail page. */
export function EditTicketRoutePage() {
  const { requestId } = useParams();
  if (!requestId) return <Navigate to="/psm/tickets" replace />;
  return <Navigate to={`/psm/tickets/${encodeURIComponent(requestId)}`} replace />;
}
